// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart {
    --vis-nested-donut-background-color: #ccc;
    /* --vis-nested-donut-segment-stroke-color: #000; */
}`, "",{"version":3,"sources":["webpack://./src/examples/misc/nested-donut/segment-values/styles.module.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,mDAAmD;AACvD","sourcesContent":[".chart {\n    --vis-nested-donut-background-color: #ccc;\n    /* --vis-nested-donut-segment-stroke-color: #000; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chart": `chart`
};
export default ___CSS_LOADER_EXPORT___;
